export const PaymentPlanType = {
  key: 1209,
  value: 'PaymentType',
};
